import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useProject } from '../../context/ProjectContext';
import useWorkspaceRouting from '../../hooks/useWorkspaceRouting';
import { TestCaseOptimization } from '../test-cases';
import LearningInsights from './LearningInsights';
import { Breadcrumbs, ErrorState, PageScaffold, Tabs } from '../ui';

/**
 * ANALYZE · Test Intelligence / AI & Learning
 */
const TestIntelligencePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = searchParams.get('tab') || 'insights';
  const [tab, setTab] = useState(initial);
  const { selectedProject } = useProject();
  const { getProjectIdFromURL } = useWorkspaceRouting();
  const projectId = getProjectIdFromURL() || selectedProject?.id || null;

  useEffect(() => {
    const fromQuery = searchParams.get('tab');
    if (fromQuery && fromQuery !== tab) setTab(fromQuery);
  }, [searchParams, tab]);

  const changeTab = (id) => {
    setTab(id);
    setSearchParams({ tab: id });
  };

  return (
    <PageScaffold
      title="AI & Learning"
      description="Analyze failures, coverage gaps, and learning signals across your suite."
      breadcrumbs={<Breadcrumbs items={[{ label: 'Insights' }, { label: 'AI & Learning' }]} />}
      compact
    >
      <Tabs
        activeId={tab}
        onChange={changeTab}
        tabs={[
          { id: 'insights', label: 'Quality Insights' },
          { id: 'suggestions', label: 'AI Suggestions' },
          { id: 'learning', label: 'Learning' },
        ]}
      />

      <div style={{ marginTop: 12 }}>
        {tab === 'insights' && (
          <div className="rt-legacy-embed">
            {projectId ? (
              <TestCaseOptimization />
            ) : (
              <ErrorState
                title="Unable to load insights"
                description="Please select a project before continuing."
              />
            )}
          </div>
        )}
        {tab === 'suggestions' && (
          <div className="rt2-panel">
            <div className="rt2-panel__body">
              <h3 style={{ marginTop: 0, fontSize: 16 }}>Available AI entry points</h3>
              <p className="rt2-muted" style={{ marginTop: 0 }}>
                AI stays contextual — use it from the entity you are working on. No fabricated results.
              </p>
              <ul className="rt2-muted" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
                <li>Generate Test Cases from requirements</li>
                <li>Generate Automation from case steps</li>
                <li>Analyze Failures from execution detail</li>
                <li>Suggest Coverage from Quality Insights</li>
                <li>Find Similar Tests from optimization</li>
              </ul>
            </div>
          </div>
        )}
        {tab === 'learning' && <LearningInsights />}
      </div>
    </PageScaffold>
  );
};

export default TestIntelligencePage;
